<template>
<b-row class="ot-main-panel no-gutters">
    <b-col v-if="loaded === false">
        <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
             <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <b-col class="text-right">
                <otif-button class="OTSecondary" style="margin-top: 0.35rem;" @click.native="filter" id="filterexec" :title="ecmResourceStrings.tipFilter" >{{ecmResourceStrings.lblFilter}}</otif-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6">
                    <otif-dateInput
                        :name="start_date"
                        :label="ecmResourceStrings.lblStartDate"
                        :datePickerOptions="datePickerOptions"
                        v-model="start_date">
                    </otif-dateInput>
                </b-col>
            <b-col cols="12" md="6">
                    <otif-dateInput
                        name="end_date"
                        :label="ecmResourceStrings.lblEndDate"
                        :datePickerOptions="datePickerOptions"
                        v-model="end_date">
                    </otif-dateInput>
                </b-col>
        </b-row>
        <b-row>
            <b-col >
                <otif-ecm-table-info
                    ref="table"
                    :sortCallback="sort"
                    :totalRowsCallback="totalRows"
                    :rows="warnings"
                    :columns="columns"
                    :paginated="true"
                    :pageSizeCallback="setPageSize"
                    :selectPageCallback="selectPage"
                    :currentPageCallback="currentPage"
                    @pageSize="setPageSize">
                    <template slot="empty">
                       {{ecmResourceStrings.msgNoInfo}}
                    </template>
                </otif-ecm-table-info>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import ecmRepositoryDefinition from '@/ecm/collections/ecmrepodefinitions.js';
import { sortOn } from '../../../utils/commonECM.js';
import axios from 'axios';
import { showMessage} from '../../../utils/commonECM.js';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import { getguivalue } from '../../../utils/commonECM.js';
import Collection from '@/collections/basic.js';

export default {

    props: ['ecmrepositoryid', 'ecmrepositoryname', 'ecmrepositorytype'],
 
    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),  
            collection: new Collection({paginated: true}),
            partitions:[],
            messageDlg:false,
            datePickerOptions: {
                format: 'YYYY-MM-DD',
                keepInvalid: true,
                
            },
            start_date:'',
            end_date:'',
            iWarningsPagesNum:0,
            iCurrentWarningsPage:0,
            docsData : null,//contains all data
            docsMain : null,//current page
            arrayDocs :null,//all pages in array
            columns: [
            {
                name: 'partition',
                label: 'Partition Description',
                sortable: true,
                editable:false,
                render(row) {
                    return row.partitionId;
                }
            },{
                name: 'documentId',
                label: 'Object ID',
                sortable: true,
                editable:false,
                width:'15%',
                render(row) {
                    return row.documentId;
                }
            },{    
                name: 'modifiedDate',
                label: 'Modified Date',
                sortable: true,
                editable:false,
                render(row) {
                    return row.modifiedDate;
                }
            },{ 
                name: 'parentId',
                label: 'Parent ID',
                sortable: true,
                editable:false,
                width:'10%',
                render(row) {
                    return row.parentId;
                }
            },{ 
                name: 'objectType',
                label: 'Object Type',
                sortable: true,
                editable:false,
                render(row) {
                    return row.objectType;
                }
            },{ 
                name: 'status',
                label: 'Status',
                sortable: true,
                editable:false,
                width:'10%',
                render(row) {
                    return row.status;
                }
            },{
                name: 'documentSize',
                label: 'Document Size',
                sortable: true,
                editable:false,
                width:'10%',
                render(row) {
                    return row.documentSize;
                }
            }],
            loaded: false
        }
    },

    computed: {
         warnings() {
            return this.collection.resources;
        }
    },

    methods: {
        refresh(){
            this.loaded = true;
        },

        sort(colNumber, dir) {
            const fieldName = this.columns[colNumber].name;
            this.collection.resources.sort(sortOn(fieldName, dir));
        },

        totalRows() {
            return this.collection.resources.length;
        },

        setPageSize(pageSize) {
            this.collection.setPageSize(pageSize);
            this.collection.selectPage(0);
        },

        selectPage(page) {
            this.$refs['table'].currentPage = page;
            this.current_page = page;
        },

        currentPage() {
            return this.collection.current_page;
        },

        showFullMessage(row){
            var that = this;
            if(row.message)
            {
                showMessage(this, 'info', that.ecmResourceStrings.ttlWarnings,'', true, row.message);
            }
        },

        filter(){
            this.getData().then((response) => {
            
            });
        },

        getPartitionName:function(id)
        {
            var name = '';
                         
            var that = this;
                         
            for (var countx = 0; countx < that.partitions.length; countx++)
            {
                if(that.partitions[countx].id == id)
                {
                    name = that.partitions[countx].name;
                                
                    break;
                }
            }
                         
            return name;
        },

        getData()
        {
            var that = this;
            that.docsMain=[];
            that.arrayDocs=[];
            that.docsData=[];
            if(that.collection.resources)
            {
                while(that.collection.resources.length > 0) {that.collection.resources.pop();}
            }
                
            var action = that.ecmrepositoryid + "/documentStatus";
            if(that.start_date != "" && that.end_date != "")
            {
                action = action + "?fromDate=" + that.start_date + "&toDate=" + that.end_date;
            }
            return new Promise((resolve, reject) => {
                axios.get('/mtm-gateway-api/v1/services/ecm/ECMRepositories/' + action, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then((res) => {
                    if (res.data) {   
                        var otputtext='';
                        const documentStatusDetails = res.data.documentStatusDetails;
                        if(documentStatusDetails)
                        {
                            const len =documentStatusDetails.length;
                            for(var i=0; i<len; i++)
                            {
                                const oneelement = documentStatusDetails[i];
                                if(oneelement)
                                {                                                                                                                    
                                    const partitionId = oneelement.partitionId;
                                    const partition = that.getPartitionName(partitionId);
                                                
                                    var repositoryId = "";
                                    const doc = oneelement.repositoryId;
                                    if (doc)
                                    {
                                        repositoryId = doc;
                                    }
                                            
                                    var documentId = "";
                                    const sttim = oneelement.documentId;
                                    if (sttim)
                                    {
                                        documentId = sttim;
                                    }
                                            
                                    var modifiedDatex = "";
                                    const modifiedDateyy = oneelement.modifiedDate;
                                    if(modifiedDateyy)
                                    {
                                        const d = new Date(modifiedDateyy);
                                        if(d == "Invalid Date")
                                        {
                                            modifiedDatex = modifiedDateyy.toLocaleString();
                                        }
                                        else
                                        {
                                            modifiedDatex = d.toLocaleString(); 
                                        }
                                    }

                                    const parentId = oneelement.parentId;
                                    const objectType = getguivalue('documentstatusobjecttype', oneelement.objectType);
                                    var documentSize = 0;
                                    const documentSizex = oneelement.documentSize;
                                    if (documentSizex)
                                    {
                                        documentSize = documentSizex;
                                    }
                                    var statusx = "";
                                    if(oneelement.status)
                                    {
                                        statusx = getguivalue('documentstatusstatus', oneelement.status);
                                    }
                                      
                                    that.docsData.push({
                                        "documentId" : documentId, 
                                        "modifiedDate" : modifiedDatex, 
                                        "parentId": parentId, 
                                        "status" : statusx, 
                                        "documentSize" : documentSize, 
                                        "partitionId" : partition,
                                        "objectType" : objectType
                                    });
                                }
                            }
                            //fill to array
                            var k = 0;
                            var documents = [];
                            for (var cnt = 0; cnt < that.docsData.length; cnt++)
                            {
                                k++;
                                if(k == 1)
                                {
                                    documents = [];
                                }
                                documents.push(that.docsData[cnt]);
                                if(k == that.iWarningsPagesNum)
                                {
                                    that.arrayDocs.push(documents);
                                    k = 0;
                                }
                                    
                                if(cnt == that.docsData.length - 1)
                                {
                                    that.arrayDocs.push(documents);
                                }
                            }
                                    
                            if(that.arrayDocs.length > 0)
                            {
                                that.docsMain = that.arrayDocs[that.iCurrentWarningsPage];
                                for (var countx = 0; countx < that.docsMain.length; countx++)
                                {
                                    that.collection.resources.push(that.docsMain[countx]);
                                }
                            }
                        }
                    }
                    resolve();
                })
                .catch((err) => {
                    that.loaded = true;
                    this.$snotify.clear();
                    if(err.message)
                    {
                        this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
                    }
                    else  if(err.response)
                    {
                        this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
                    }
                    reject(err);
            });
        });}
    },

    components: {
        ECMErrorDialog
    },
    
    mounted() {
        if(this.ecmrepositorytype == "dbms_generic_v1")
        {
             var breadcrumbs = [{
            name: 'reports',
            meta: { label: 'Reports' }
        },{
            name: 'rdbms-reports',
            meta: { label: 'RDBMS Crawler Reports' }
        },{
            name: 'reports-document-rdbms',
            meta: { label: 'Document Status' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
        }
        else{
         var breadcrumbs = [{
            name: 'reports',
            meta: { label: 'Reports' }
        },{
            name: 'ecm-reports',
            meta: { label: 'ECM Crawler Reports' }
        },{
            name: 'reports-document',
            meta: { label: 'Document Status' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
        }
    },
   
    created() {
        var that = this;
        that.partitions=[];
    
        axios.get('/mtm-gateway-api/v1/services/ecm/ECMRepositories/'+ that.ecmrepositoryid)
        .then((res) => {
            this.$snotify.clear();
            if (res.data) {
                //partitions and connections come from repositories
                //ECMRepositoriesStatusListView line 90
                const parameters = res.data.configData;
                if(parameters)
                {
                    const len = parameters.length;
                    if(len!=0)
                    {
                        for(var i=0; i<len; i++)
                        {
                            const oneelement = parameters[i];
                            if(oneelement)
                            {
                                const paramfullName = oneelement.name;
                                var paramIndex = 0;//for partitions
                                var paramName = '';
                                //parse name to see what we have
                                //could be one word
                                //repoParam.0.hostName, repoPartitionTask.0.folderPathOrId, repoExcludedFolder.1.folderPathOrId
                                const namesArray = paramfullName.split(".");
                                const lennames = namesArray.length;
                                if(lennames > 1)
                                {
                                    if (namesArray[0] == "repoPartition")
                                    {
                                        paramIndex = namesArray[1]; 
                                        paramName = namesArray[2]; 
                                        if(paramName == 'description')
                                        {
                                            that.partitions.push({'id':paramIndex, 'name':parameters[i].value});
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                this.getData().then((response) => {
                    this.loaded = true;
                });
                return;  
            }
   
        })
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
            }
            else  if(err.response)
            {
                this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
        });
        return;    
      
    },
}

</script>
